import $ from 'jquery';

export default () => {
  // Show modal.
  $(document).on('click', '.modal-caller', function(e) {
    e.preventDefault();

    $($(this).attr('data-target') + '.modal').addClass('show');
  });

  // Close modal.
  $('.close-modal').click(function(e) {
    e.preventDefault();

    const $this = $(this);
    const target = $this.data('target');
    let $modal = null;

    if (target) {
      $modal = $(target);
    } else {
      $modal = $this.closest('.modal');
    }

    $modal.removeClass('show');
    $('#pdf-container', $modal).remove();
  });

  // Close all modals whenever user clicks outside modal.
  $(window).click(function(e) {
    const $modal = $(e.target);

    if ($modal.is('.modal') && $modal.hasClass('show')) {
      $modal.removeClass('show');
      $('#pdf-container', $modal).remove();
    }
  });
};
